export default __webpack_public_path__ + "static/media/MMUN.ce585285.svg";